// Google and Meta assets both live on the Settings "Platforms" tab, so the
// "reconnect" link is the same for either platform — only the wording changes.
export const SETTINGS_PLATFORMS_ANCHOR = '/settings#platforms'

// The Platforms tab picks its child panel from a `platform` query param rather
// than from the hash (src/pages/Settings.js), so a Google-caused error can open
// the Google panel instead of the Meta one the tab opens by default.
export const SETTINGS_PLATFORMS_GOOGLE_ANCHOR = '/settings?platform=google#platforms'

const PROVIDER_NAMES = {
  google: 'Google',
  fb: 'Meta',
  meta: 'Meta',
  facebook: 'Meta',
  instagram: 'Meta',
}

// Display name for a permission error's platform. Defaults to Meta — the
// historical single-platform case and the safest fallback when unknown.
export function permissionErrorProviderName(platform) {
  return PROVIDER_NAMES[platform] || 'Meta'
}

// Settings link for a single platform's asset. Same defaulting as
// permissionErrorProviderName: anything but Google lands on the Meta panel.
export function settingsPlatformsHref(platform) {
  return PROVIDER_NAMES[platform] === 'Google'
    ? SETTINGS_PLATFORMS_GOOGLE_ANCHOR
    : SETTINGS_PLATFORMS_ANCHOR
}

// Provider wording for a message about a whole setup rather than one asset, so
// a dual-platform failure names both instead of picking one.
export function providerNamesForPlatforms(platforms) {
  const names = (platforms || []).map((platform) => PROVIDER_NAMES[platform])
  const hasGoogle = names.includes('Google')
  const hasMeta = names.includes('Meta')
  if (hasGoogle && hasMeta) return 'Meta & Google'
  if (hasGoogle) return 'Google'
  return 'Meta'
}

// Label for "last updated on <provider>" status text. A task can touch both
// platforms at once on a dual-published event, so names both when both are
// published. Defaults to Meta, same as permissionErrorProviderName.
export function updatedProviderLabel(campaignStatus) {
  const activeGoogle = !!campaignStatus?.google?.published
  const activeMeta = !!campaignStatus?.meta?.published
  if (activeGoogle && activeMeta) return 'Meta & Google'
  if (activeGoogle) return 'Google'
  if (activeMeta) return 'Meta'
  return 'Meta'
}
